exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "objective > .column{\r\n\tdisplay: flex !important;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n}", ""]);

